import { ArtistsMenu } from "@/components/ui/menu/ArtistsMenu"
import { BottomNavButton } from "@/components/ui/navigation/BottomNavButton"
import { getArtistMainNavItems, type BadgeState } from "@/lib/navigationItems"
import { useUserData } from '@/hooks/useUserData';
import { useUnreadChatsCount } from '@/hooks/useUnreadChatsCount';
import { useBookingSystem } from '@/contexts/BookingSystemContext'
import { isNative } from '@/lib/platform';

export function ArtistsBottomNav() {
  const { artistId } = useUserData();
  const { hasBookingSystem, subscription } = useBookingSystem();
  const { count: unreadCount } = useUnreadChatsCount();
  const isTrial = subscription?.status === 'trial';
  const mainItems = getArtistMainNavItems({ hasBookingSystem: !!hasBookingSystem, isTrial: !!isTrial });

  // Build badge state
  const badgeState: BadgeState = {
    unreadCount,
    isNative: isNative(),
  };

  return (
    <div className="bottom-nav-container bottom-nav flex items-center justify-around">
      {mainItems.map((item) => (
        <BottomNavButton
          key={item.id}
          item={item}
          badgeState={badgeState}
          artistId={artistId ?? undefined}
        />
      ))}

      {/* More (Menu) */}
      <ArtistsMenu />
    </div>
  )
}
